export const ARTICLE_TYPES = {
  internal: 'internal',
  external: 'external',
};

export const ARTICLE_CARD_TYPES = {
  fullImage: 'full-image',
  splitImage: 'split-image',
};
